<template>
  <div :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <template>
            <a-col :md="8" :sm="12">
              <a-form-item :label="$t(I18N_KEY + 'dataDate')">
                <a-range-picker v-model="queryParam.createdTime" format="YYYY-MM-DD" :allowClear='allowClear'/>
              </a-form-item>
            </a-col>
          </template>

          <a-col :md="6" :sm="8">
            <a-form-item :label="$t(I18N_KEY + 'mobile')">
              <a-input :placeholder="$t('enter') + ' ' + $t(I18N_KEY + 'mobile')" v-model="queryParam.mobile" :allowClear='allowClear'></a-input>
            </a-form-item>
          </a-col>

          <a-col :md="16" :sm="12">
            <a-form-item :label="$t(I18N_KEY + 'teleMarketUser')">
              <template>
                <a-select
                  v-model:value="queryParam.user"
                  show-search
                  :placeholder="$t('enter') + ' ' + $t(I18N_KEY + 'teleMarketUser')"
                  style="width: 100%"
                  mode="multiple"
                  :allowClear='allowClear'
                >
                  <a-select-option value="">{{ $t(I18N_KEY+'all') }}</a-select-option>
                  <a-select-option v-for="item in teleMarketUsers" :value="item.value">
                    {{item.label }}
                  </a-select-option>
                </a-select>
              </template>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
<!--          <a-col :md="8" :sm="12">-->
<!--            <a-form-item :label="$t(I18N_KEY + 'loanType')">-->
<!--              <a-select v-model="queryParam.loanType" :placeholder="$t('select')" style="width: 100%" mode="multiple" :allowClear='allowClear'>-->
<!--                <a-select-option value="">{{ $t(I18N_KEY+'all') }}</a-select-option>-->
<!--                <a-select-option v-for='item in loanTypes' :key='item.label'>-->
<!--                  &lt;!&ndash;                  {{$t(I18N_KEY + 'loanType_' + item.label)}}&ndash;&gt;-->
<!--                  {{item[fieldName]}}-->
<!--                </a-select-option>-->
<!--              </a-select>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
          <a-col :md="16" :sm="12">
            <a-form-item :label="$t(I18N_KEY + 'type')">
              <a-select v-model="queryParam.type" :placeholder="$t('select')" style="width: 100%" mode="multiple" :allowClear='allowClear'>
                <a-select-option value="">{{ $t(I18N_KEY+'all') }}</a-select-option>
                <a-select-option v-for='item in types' :key='item.value'>
                  {{item[fieldName]}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
<!--          <a-col :md="8" :sm="12">-->
<!--            <a-form-item :label="$t(I18N_KEY + 'userGroupName')">-->
<!--              <a-select v-model="queryParam.groupId" :placeholder="$t('select')" style="width: 100%;" mode="multiple" :allowClear='allowClear'>-->
<!--                <a-select-option value="">{{ $t(I18N_KEY+'all') }}</a-select-option>-->
<!--                <a-select-option v-for="item in userGroups" :value="item.value">-->
<!--                  {{item[fieldName]}}-->
<!--                </a-select-option>-->
<!--              </a-select>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
          <a-col :md="16" :sm="12">
            <a-form-item :label="$t(I18N_KEY + 'app')">
              <a-select v-model="queryParam.appSsid" :placeholder="$t('select')" style="width: 100%;" mode="multiple" :allowClear='allowClear'>
                <a-select-option value="">{{ $t(I18N_KEY+'all') }}</a-select-option>
                <a-select-option v-for="item in apps" :value="item.appSsid">
                  {{ item.appSsid + '/' + item.appName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <a-form-item :label="$t(I18N_KEY + 'custId')">
              <a-input :placeholder="$t('enter') + ' ' + $t(I18N_KEY + 'custId')" v-model="queryParam.custId" :allowClear='allowClear'></a-input>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <a-form-item :label="$t(I18N_KEY + 'orderId')">
              <a-input :placeholder="$t('enter') + ' ' + $t(I18N_KEY + 'orderId')" v-model="queryParam.orderId" :allowClear='allowClear'></a-input>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <a-form-item :label="$t(I18N_KEY + 'dataId')">
              <a-input :placeholder="$t('enter') + ' ' + $t(I18N_KEY + 'dataId')" v-model="queryParam.dataId" :allowClear='allowClear'></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="$t(I18N_KEY + 'keyword')">
              <a-input :placeholder="$t('enter') + ' ' + $t(I18N_KEY + 'keyword')" v-model="queryParam.keyword" :allowClear='allowClear'></a-input>
            </a-form-item>
          </a-col>

          <a-col :md="8" :sm="8">
            <a-form-item :label="$t(I18N_KEY + 'followUpStatus')">
              <a-select v-model="queryParam.followUpStatus" :placeholder="$t('select')" style="width: 100%" mode="multiple" :allowClear='allowClear'>
                <a-select-option value="">{{ $t(I18N_KEY+'all') }}</a-select-option>
                <a-select-option v-for='item in followUpStatuses' :key='item.value'>
                  {{item[fieldName]}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="10" :sm="8">
            <a-form-item :label="$t(I18N_KEY + 'notApplyReason')">
              <a-select v-model="queryParam.notApplyReason" :placeholder="$t('select')" style="width: 100%" mode="multiple" :allowClear='allowClear'>
                <a-select-option value="">{{ $t(I18N_KEY+'all') }}</a-select-option>
                <a-select-option v-for='item in followUpNotApplyReasons' :key='item.value'>
                  {{item[fieldName]}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :md="7" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('search') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('reset') }}</a-button>
              <a-button type="primary" @click="downLoadData" icon="search" style="margin-left: 8px">{{ $t('exportFile') }}</a-button>
            </span>
          </a-col>
        </a-row>

      </a-form>
      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        bordered>
        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)" v-if='record.attachment != null'>{{ $t('view') }}</a>
        </span>
      </a-table>
      <div style="margin-top: 15px; text-align: right;">
        <v-pagination
          v-if="total"
          :page-num="form.pageNum"
          :page-size="form.pageSize"
          :total="total"
          @change="handleTableChange" />
      </div>
    </div>
    <tele-market-attachment ref="attachment" :attachments='attachments' @ok="modalFormOk"></tele-market-attachment>
  </div>
</template>
<script>
import { filterObj } from '@/utils/util';
import { followUpRecordList, followUpRecordBaseData } from '@/webpublicapi/teleMarket'
import vModal from "@/views/webpublic/modules/Modal";
import {mapGetters} from "vuex";
import moment from 'moment/moment'
import exportFile from "@/webpublicapi/exportFile";
import imageMixin from '@/mixins/image-mixin';
import TeleMarketAttachment from './TeleMarketAttachment';
// import { defineComponent } from 'vue';
const I18N_KEY = 'teleMarket.';
export default {
  name: 'teleMarketFollowUpRecord',
  components: {
    vModal,
    TeleMarketAttachment
  },
  mixins: [imageMixin],
  data () {
    return {
      I18N_KEY,
      form: {
        pageNum: 1,
        pageSize: 30,
      },
      view: false,
      allowClear: true,
      total: 0,
      dataSource: [],
      apps: [],// Package list
      teleMarketUsers: [],// Telemarketer list
      userGroups: [],// Telemarketer list
      types: [],// Type list
      followUpStatuses: [],
      followUpNotApplyReasons: [],
      attachments: [],
      visible: false,
      // loanTypes: [{"label":"1", "value":"1"},{"label": "2", "value":"2"},{"label":"3","value":"3"},{"label":"4","value":"4"},{"label":"5","value":"5"}],// First/repeat loan type1-First collection,2-Repeat loan,3-First/repeat loan,4-Early settlement
      // Query conditions
      queryParam: {
        "createdTime": [],
        "appSsid": [],
        "type": [],
        "user": [],
        "custId": null,
        "orderId": null,
        "dataId": null,
        "keyword": '',
        "mobile": '',
        "followUpStatus": [],
        "notApplyReason": [],
      },
      fieldName: 'textCn',
      loading: false,
      // Table header
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    ...mapGetters('language', ['languageStorage']),
    columns() {
      return [
        {
          title: this.$t(I18N_KEY + 'id'),
          align: 'left',
          width: '60',
          dataIndex: 'id'
        },
        {
          title: this.$t(I18N_KEY + 'dataId'),
          align: 'left',
          width: '60',
          dataIndex: 'dataId'
        },
        {
          title: this.$t(I18N_KEY + 'assignTime'),
          align: 'center',
          width: '100',
          dataIndex: 'assignTime'
        },
        {
          title: this.$t(I18N_KEY + 'type'),
          align: 'center',
          width: '200',
          dataIndex: 'type',
          customRender: (text, record) => {
            var text = text;
            if(text != undefined && text != null && text != '') {
              for(var i in this.types) {
                if(text === this.types[i].value) {
                  return this.types[i][this.fieldName]
                }
              }
            } else {
              return '';
            }
          },
        },
        {
          title: this.$t(I18N_KEY + 'teleMarketUser'),
          align: 'center',
          width: '120',
          dataIndex: 'user',
          customRender: (text, record) => {
            var text = text;
            return this.getUserLabel(text);
          }
        },
        {
          title: this.$t(I18N_KEY + 'mobile'),
          align: 'center',
          width: 120,
          dataIndex: 'mobileEncrypt'
        },
        // {
        //   title: this.$t(I18N_KEY + 'userGroupName'),
        //   align: 'center',
        //   width: '120',
        //   dataIndex: 'groupId',
        //   // scopedSlots: {customRender: 'user'},
        //   customRender: (text, record) => {
        //     var text = text;
        //     for(var i in this.userGroups) {
        //       if(text == this.userGroups[i].value) {
        //         return this.userGroups[i][this.fieldName]
        //       }
        //     }
        //     return text;
        //   }
        // },
        {
          title: this.$t(I18N_KEY + 'app'),
          align: 'center',
          width: '150',
          dataIndex: 'appSsid',
          customRender: (text, record) => {
            var text = text;
            return this.getAppName(text);
          }
        },
        {
          title: this.$t(I18N_KEY + 'custId'),
          align: 'center',
          width: 100,
          dataIndex: 'custId'
        },
        {
          title: this.$t(I18N_KEY + 'orderId'),
          align: 'center',
          width: 100,
          dataIndex: 'orderId'
        },
        {
          title: this.$t(I18N_KEY + 'followUpStatus'),
          align: 'center',
          width: 200,
          dataIndex: 'followStatuses',
          customRender: (text, record) => {
            var text = text;
            var result = ''
            for(var item in text) {
              for(var i in this.followUpStatuses) {
                if(text[item] === this.followUpStatuses[i].value) {
                  if(result === '') {
                    result = this.followUpStatuses[i][this.fieldName]
                  } else {
                    result = result + "," + this.followUpStatuses[i][this.fieldName]
                  }
                }
              }
            }
            return result;
          }
        },
        {
          title: this.$t(I18N_KEY + 'notApplyReason'),
          align: 'center',
          width: 150,
          dataIndex: 'notApplyReason',
          customRender: (text, record) => {
            var text = text;
            if(text != undefined && text != null && text != '') {
              // return this.$t(I18N_KEY + 'notApplyReason_' + text)
              for(var i in this.followUpNotApplyReasons) {
                if(text === this.followUpNotApplyReasons[i].value) {
                  return this.followUpNotApplyReasons[i][this.fieldName]
                }
              }
            } else {
              return '';
            }
          }
        },
        {
          title: this.$t(I18N_KEY + 'remark'),
          align: 'center',
          width: 250,
          dataIndex: 'remark'
        },
        {
          title: this.$t(I18N_KEY + 'followUpTime'),
          align: 'center',
          width: 150,
          dataIndex: 'followUpTime'
        },
        {
          title: this.$t('action'),
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 150,
          scopedSlots: {customRender: 'action'}
        }
      ]
    },
  },
  created () {
    this.loadBaseData();// Load telemarketer list, type list, package list
    // this.loadData(1);
  },
  methods: {
    searchQuery () {
      this.loadData(1)
    },
    loadBaseData() {
      followUpRecordBaseData({}).then((res) => {
        if (res.code === 1000) {
          this.teleMarketUsers = res.data.seats;
          this.types = res.data.types;
          this.apps = res.data.apps;
          this.followUpStatuses = res.data.followUpStatuses;
          this.followUpNotApplyReasons = res.data.followUpNotApplyReasons;
          // this.loanTypes = res.data.loanTypes;
          // this.userGroups = res.data.userGroups;
        } else {
          this.$message.error(res.msg)
        }
      }).catch(e => {
        this.$message.error(e.message);
      })
    },
    loadData(arg) {
      // Load data If params passed1Then load first page content
      if (arg === 1) {
        this.form.pageNum = 1
      }
      this.loading = true
      var params = this.getQueryParams()// Query conditions
      followUpRecordList(Object.assign({}, params)).then((res) => {
        if (res.code === 1000) {
          this.total = res.data.total
          this.dataSource = res.data.rows
        } else {
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false;
        this.$message.error(e.message);
      })
    },
    handleDetail(record){
      this.attachments = record.attachmentUrl;
      this.visible = true;
      this.$refs.attachment.open();
    },
    getQueryParams() {
      const { createdTime } = this.queryParam;
      const data = {
        ...this.queryParam,
        assignStartDate: createdTime && this.transformTime(createdTime[0]),
        assignEndDate: createdTime && this.transformTime(createdTime[1]),
      }
      // console.log(this.queryParam.createdTime)
      if(this.queryParam.createdTime.length === 0) {
        data['assignStartDate'] = ''
        data['assignEndDate']=''
      }
      var param = Object.assign({}, data)
      param.pageNum = this.form.pageNum
      param.pageSize = this.form.pageSize
      return filterObj(param)
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    transformStringToLow(str) {
      return str && str.toLocaleLowerCase();
    },
    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum;
      this.form.pageSize = pageSize;
      this.loadData();
    },
    searchReset() {
      var that = this
      that.queryParam.appSsid = []
      that.queryParam.type = []
      that.queryParam.user = []
      that.queryParam.createdTime = []
      that.queryParam.notApplyReason = []
      that.queryParam.followUpStatus = []
      that.queryParam.custId = null
      that.queryParam.orderId = null
      that.queryParam.dataId = null
      that.queryParam.keyword = ''
      that.queryParam.mobile = ''
    },
    getUserLabel(user) {
      for(var item in this.teleMarketUsers) {
        var userObj = this.teleMarketUsers[item];
        if(userObj.value === user){
          return userObj.label;
        }
      }
    },
    getAppName(appSsid) {
      for(var item in this.apps) {
        var appObj = this.apps[item];
        if(appObj.appSsid === appSsid) {
          return appSsid+ '/'+appObj.appName;
        }
      }
      return appSsid;
    },
    getQueryParams1() {
      const { createdTime } = this.queryParam;
      const data = {
        ...this.queryParam,
        assignStartDate: createdTime && this.transformTime(createdTime[0]),
        assignEndDate: createdTime && this.transformTime(createdTime[1]),
      }
      if(this.queryParam.createdTime.length === 0) {
        data['assignStartDate'] = ''
        data['assignEndDate']=''
      }
      return Object.assign({}, data)
    },
    downLoadData () {
      const params = this.getQueryParams1()// Query conditions
      const file = {
        fileUrl: '/api/web/webpublic/telemarket/followUpRecord/list/exportWithImage?assignStartDate=' + this.checkParam(params.assignStartDate)
          + '&assignEndDate=' + this.checkParam(params.assignEndDate)
          + '&user=' + this.checkArrayParam(params.user)
          + '&type=' + this.checkArrayParam(params.type)
          + '&appSsid=' + this.checkArrayParam(params.appSsid)
          + '&followUpStatus=' + this.checkArrayParam(params.followUpStatus)
          + '&notApplyReason=' + this.checkArrayParam(params.notApplyReason)
          + '&custId=' + this.checkParam(params.custId)
          + '&dataId=' + this.checkParam(params.dataId)
          + '&orderId=' + this.checkParam(params.orderId)
          + '&keyword=' + this.checkParam(params.keyword)
          + '&mobile=' + this.checkParam(params.mobile),
        fileName: 'teleMarketFollowUpRecord.xlsx',
      }
      this.loading = true;
      exportFile(file).catch(e => {
        this.$message.error(e.message);
      }).finally(() => {
        this.loading = false;
      })
    },
    checkParam(p){
      if(p===null || p === 'null' || p === undefined || p === 'undefined') {
        return '';
      }
      return p;
    },
    checkArrayParam(p){
      if(p===null || p === 'null' || p === undefined || p === 'undefined') {
        return [];
      }
      return p;
    },
  },
  watch: {
    languageStorage: {
      handler (lang) {
        if (lang == 'en-US') {
          this.fieldName = 'textEn';
        } else if (lang == 'es') {
          this.fieldName = 'textEs';
        } else {
          this.fieldName = 'textEn';
        }
      },
      immediate: true,
    }
  },
}
</script>
<style lang="less" scoped>
.file-box {
  float: left;
  width: 50px;
  height: 50px;
  margin-right: 10px;
  margin: 0 8px 8px 0;

  .file-item {
    width: 100%;
    height: 100%;
    position: relative;
    border: 1px solid #d9d9d9;
    border-radius: 4px;

    .file-preview {
      padding: 8px;
      width: 182px;
      height: 142px;
    }

    .file-label {
      margin: 0;
      text-align: center;
      border-bottom: 1px solid #d9d9d9;
      padding: 8px;
      font-weight: 500;
      font-size: 16px;
    }
  }
}
</style>